export default class CategoriAlert {
    public id: string;
    public description: string;
    public name: string;
    public descriptionEn: string;
    public nameEn: string;

    constructor(data: any) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.nameEn = data.nameEn;
        this.descriptionEn = data.descriptionEn;
    }
}